import Head from "next/head";
import Navbar from "../components/navbar";
import "../styles/globals.css";
import { motion } from "framer-motion";
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import Footer from "../components/sections/footer";
import GoUp from "../components/goUp";
import Script from "next/script"

config.autoAddCss = false

function MyApp({ Component, pageProps, router }) {
  return (
    <>
      <main>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta charSet="utf-8" />
          <title>Sara Fontoura</title>
          <meta
            name="description"
            content="Sara Fontoura - Fotógrafa Profissional"
          />
          {/* Twitter */}
          <meta name="twitter:card" content="summary" key="twcard" />
          <meta name="twitter:creator" content="" key="twhandle" />
          {/* Open Graph */}
          <meta
            property="og:url"
            content="https://sarafontoura.com"
            key="ogurl"
          />
          <meta property="og:image" key="ogimage" content="/fotos/sara.jpg" />
          <meta
            property="og:site_name"
            content="Sara Fontoura"
            key="ogsitename"
          />
          <meta property="og:title" content="Sara Fontoura" key="ogtitle" />
          <meta
            property="og:description"
            content="Sara Fontoura - Fotógrafa Profissional"
            key="ogdesc"
          />
          <link rel="icon" href="/favicon.ico" />
        </Head>
        <Script
          src="https://www.googletagmanager.com/gtag/js?id=G-WEBCD2N08N"
          strategy="afterInteractive"
        />
        <Script id="google-analytics" strategy="afterInteractive">
          {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-WEBCD2N08N');
        `}
        </Script>
        <Navbar />
        <motion.div
          key={router.route}
          initial="initial"
          animate="animate"
          variants={{
            initial: {
              opacity: 0,
            },
            animate: {
              opacity: 1,
            },
          }}
        >
          <Component {...pageProps} />
        </motion.div>
      </main>
      <Footer />
      <GoUp />
    </>
  )
}

export default MyApp;
